import env from '../../env/src_config'

export const Log = (content) => {
    if (env.is_development) {
        console.log(content);
    }
}
